import React from 'react'

export default props => (
	<div className='box box-success' style={props.style}>
		<div className='box-header with-border'>
			{props.children}
		</div>
	</div>
)
